<template>
    <span>
        <span
            class="text-primary ml-2 toggleForm"
            v-if="aplicacao.status === 1 && $temAcessoView('CTRLACS-APP-04')"
            ><i
                class="fa fa-toggle-on fa-lg icon-button"
                title="Desativar Aplicação"
                @click.stop="confirmaAtivarDesativar()"
            ></i
        ></span>
        <span
            class="text-primary ml-2 toggleForm"
            v-if="aplicacao.status === 0 && $temAcessoView('CTRLACS-APP-04')"
            ><i
                class="fa fa-toggle-off fa-lg icon-button"
                title="Ativar Aplicação"
                @click.stop="confirmaAtivarDesativar()"
            ></i
        ></span>
    </span>
</template>

<script>
import AplicacoesServicos from './AplicacoesServicos'

export default {
    props: {
        aplicacao: {
            type: Object
        }
    },

    methods: {
        confirmaAtivarDesativar() {
            this.$swal({
                title: `${
                    this.aplicacao.status == 0 ? 'Ativação' : 'Desativação'
                } da Aplicação`,
                html: `Confirma a ${
                    this.aplicacao.status == 0 ? 'ativação' : 'desativação'
                } da aplicação <b>${this.aplicacao.codigo}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.ativarDesativar()
                }
            })
        },

        ativarDesativar() {
            this.$emit('atualizarErros', [])
            this.$store.dispatch('addRequest')
            AplicacoesServicos.ativarDesativar(
                this.aplicacao,
                this.aplicacao.status == 0 ? 'ativar' : 'desativar'
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            `Aplicação ${
                                this.aplicacao.status == 0
                                    ? 'ativada'
                                    : 'desativada'
                            } com sucesso`,
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('atualizarAplicacao', response.data)
                        this.$store.dispatch('setRecarregar', true)
                    } else {
                        this.$emit('atualizarErros', response.errors)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    }
}
</script>

<style scoped>
.toggleForm {
    font-size: 1.2em;
}
</style>
